import React from 'react'
import { IconButton } from '@material-ui/core'
import { Delete as DeleteIcon } from '@material-ui/icons'
import moment from 'moment'
import List from '../../components/List'
import DashboardPage from '../../layouts/DashboardPage'
import AddDomainsDialog from './AddDomainsDialog'
import ConfirmDialog from '../../components/ConfirmDialog'

const columns = [
  { id: 'createdAt', disablePadding: true, label: 'Created' },
  { id: 'domain', disablePadding: true, label: 'Domain' },
  { id: 'actions', disablePadding: true, kind: 'actions', label: '', numeric: true }
]

export default class GlobalBlocklist extends React.Component {
  render() {
    const {
      items,
      onRemove,
      onSave,
      addDialogOpen,
      onOpenAdd,
      onCloseAdd,
      ...rest
    } = this.props

    const itemsWithActions = items.map(item => ({
      ...item,
      createdAt: moment(item.createdAt).format('YYYY-MM-DD HH:mm'),
      actions: () => (
        <ConfirmDialog
          title="Remove from blocklist"
          confirmation
          confirmationText={`Are you sure you want to remove ${item.domain} from the global blocklist?`}
          action={() => onRemove(item.id)}
          confirmButtonLabel="Remove"
        >
          <IconButton size="small">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </ConfirmDialog>
      )
    }))

    return (
      <DashboardPage
        kind='list'
        title='Global Blocklist'
        addLabel='Add Domains'
        addClick={onOpenAdd}
      >
        <List
          {...rest}
          columns={columns}
          items={itemsWithActions}
          searchable
          emptyMessage={'No domains matching the given criteria.'}
        />

        <AddDomainsDialog
          open={addDialogOpen}
          onSave={onSave}
          onClose={onCloseAdd}
        />

      </DashboardPage>
    )
  }
}
